import { useState } from 'react';

export default function useObjectElements({ initialValues }) {
  const [object, setValue] = useState(initialValues || {});

  const setObjectValue = (key, value) => {
    setValue({
      ...object,
      [key]: value,
    });
  };

  const setObject = (wholeObject) => {
    setValue({ ...wholeObject });
  };

  const setMultipleObjectValues = (newValues) => {
    setValue({ ...object, ...newValues });
  };

  const resetObjectToInitValues = () => setValue(initialValues || {});

  return {
    setObjectValue,
    setObject,
    setMultipleObjectValues,
    object,
    resetObjectToInitValues,
  };
}
